import React from 'react';
import { FlexRow, NumberInput } from 'ui-toolkit';
import generateFlexiblePercentageProps, { IPercentageProps } from '../utilities/generateFlexiblePercentageProps';
import IHasItemDataProps from './IHasItemDataProps';
import IHasItemEventProps from './IHasItemEventProps';
import IItemProps from './IItemProps';
import SharedItemCells from './SharedItemCells';
import { IPercentageOfInterestViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';
import { generateDefaultViewItem } from '../../../ui-toolkit/cdItems/data/generateDefaultViewItem';

interface IPercentageOfInterest
  extends IItemProps,
    IHasItemDataProps<IPercentageOfInterestViewItem>,
    IHasItemEventProps<IPercentageOfInterestViewItem> {}

interface IPercentageOfInterestState {
  percentageProps: IPercentageProps;
}

export default class PercentageOfInterest extends React.Component<IPercentageOfInterest, IPercentageOfInterestState> {
  constructor(props: IPercentageOfInterest) {
    super(props);
    this.onPercentChangeEvent = this.onPercentChangeEvent.bind(this);
    this.state = {
      percentageProps: generateFlexiblePercentageProps(
        this.props.data.percentage ? Number(this.props.data.percentage) : null
      ),
    };
  }

  public render() {
    const { data, hasEditPermissions } = this.props;
    const percentage = data.percentage === undefined || data.percentage === null ? null : Number(data.percentage);
    return (
      <SharedItemCells {...this.props} readOnly={!hasEditPermissions}>
        <FlexRow>
          <NumberInput
            onChange={this.onPercentChangeEvent}
            placeholder="0"
            {...this.state.percentageProps}
            name="percentage"
            value={percentage}
            readOnly={!hasEditPermissions}
            debounceOnValueChange
          />
          <span> % of Loan Amount</span>
        </FlexRow>
      </SharedItemCells>
    );
  }

  private onPercentChangeEvent(value: number | null) {
    const { data, onChange } = this.props;
    onChange({
      ...generateDefaultViewItem(),
      ...data,
      dirty: true,
      percentage: value,
    });
    this.setState({
      percentageProps: generateFlexiblePercentageProps(value),
    });
  }
}
